import { render, staticRenderFns } from "./dsFlow.vue?vue&type=template&id=50f30e4e&"
import script from "./dsFlow.vue?vue&type=script&lang=js&"
export * from "./dsFlow.vue?vue&type=script&lang=js&"
import style0 from "./dsFlow.vue?vue&type=style&index=0&id=50f30e4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports